import React from 'react';

import { Skeleton } from '../../../../components';
import type { StatsLead } from '../../../../mock-data/types';
import { LiveNumber } from '../LiveNumber';
import { Delta } from '../Delta';
import { Root, LabelRow, Lbl, PVal, DeltaRow, Sub } from './PrimaryStat.styles';

export type PrimaryStatProps = {
  data: StatsLead;
  /** While true, the figure + delta show placeholders (the endpoint is loading). */
  loading?: boolean;
};

/**
 * The lead figure of a metric card (Registrations, Gross Revenue, Deposits): a
 * label, the prominent live figure and a delta + "vs …" caption row beneath. The
 * label + caption are static chrome; the figure + delta load in.
 */
export const PrimaryStat = ({ data, loading = false }: PrimaryStatProps): React.ReactElement => {
  // A placeholder figure (`?` not wired, `N/A` failing, `–` undefined this period) has
  // no real delta, so drop the whole delta + "vs …" row rather than show a pill against it.
  const placeholder = Boolean(data.missing || data.error || data.indeterminate);
  return (
    <Root>
      <LabelRow>
        <Lbl text={data.label} tag="span" />
      </LabelRow>
      <PVal>
        <LiveNumber
          value={data.value}
          prefix={data.prefix}
          suffix={data.suffix}
          decimals={data.decimals}
          loading={loading}
          missing={data.missing}
          error={data.error}
          indeterminate={data.indeterminate}
        />
      </PVal>
      {placeholder ? null : (
        <DeltaRow>
          {loading ? <Skeleton width={48} height={16} radius={6} /> : <Delta delta={data.delta} size={14} />}
          <Sub text={data.vs} tag="span" />
        </DeltaRow>
      )}
    </Root>
  );
};

export default PrimaryStat;
